import {Component, Input} from '@angular/core';
import {BlobService} from "../../core/base/blob.service";
import moment from 'moment';
import {NotificationsModel} from "../../core/notifications/notifications.model";
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent {
  public notifications: any[] = [];
  @Input() notificationLocation: string | null = null;

  constructor(private blobService: BlobService,
              private http: HttpClient,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
    this.getNotifications();
  }

  async getNotifications() {
    try{
      const allNotifications = JSON.parse(<string>await this.blobService.getDataPhx('notices.json', 'marketing-management'));
      console.log(JSON.stringify(allNotifications));
      const activeNotifications = allNotifications.filter((notice: any) =>  notice.filterHageda !== undefined &&
        notice.filterHageda !== null &&
        this.isNoticeVisible(notice));
      console.log(JSON.stringify(activeNotifications));
      this.notifications.push(...activeNotifications.map((n: any) => new NotificationsModel(n)));
      } catch(error) {
      console.error('Error fetching notices', error);
      this.notifications = [];
    }
  }

  showNotification(filter: string) {
    let route;
    console.log(filter);
    if (this.notificationLocation !== 'login') {
      route = this.router.url.replace(/^\/|\/$/g, '');
    } else {
      route = this.activatedRoute.snapshot.routeConfig?.path;
    }
    return !(filter !== null && filter !== route && !route?.includes(filter));
  }

  private isNoticeVisible(notice: any): boolean {
    const now = new Date();

    if (!notice.start && !notice.end) {
      return true;
    }

    if (notice.start && !notice.end) {
      const startDate = new Date(notice.start);
      return now >= startDate;
    }

    if (notice.start && notice.end) {
      const startDate = new Date(notice.start);
      const endDate = new Date(notice.end);
      return now >= startDate && now <= endDate;
    }

    if (!notice.start && notice.end) {
      const endDate = new Date(notice.end);
      return now <= endDate;
    }

    return false;
  }
}
